import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import swal from 'sweetalert2';

class AddWorkTimeInSignInShiftBlock extends Component {
  constructor(props) {
    super(props);
    this.state={
      staff: 0,
      selectDate: moment(),
      selectStartTime: moment('2018-09-08T10:00'),
      selectEndTime: moment('2018-09-08T10:00'),
    }
    this.handleSelectStartTimeChange = this.handleSelectStartTimeChange.bind(this);
    this.handleSelectEndTimeChange = this.handleSelectEndTimeChange.bind(this);
    this.handleSaveWorkTime = this.handleSaveWorkTime.bind(this);
    this.handleStaffChange = this.handleStaffChange.bind(this);
    this.handleSelectDateChange = this.handleSelectDateChange.bind(this);
    this.handleDateChangeRaw = this.handleDateChangeRaw.bind(this);

  }

  handleDateChangeRaw(e){
    e.preventDefault();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.editStaff === undefined) return;
    let {expectedStart, expectedEnd} = nextProps.editStaff;
    this.setState({
      selectStartTime: expectedStart !== '無'? moment(expectedStart, 'HH:mm'):moment(),
      selectEndTime: expectedEnd !== '無'? moment(expectedEnd, 'HH:mm'):moment()
    })
  }

  handleSelectStartTimeChange(moment) {
    this.setState({
      selectStartTime: moment
    })
  }

  handleSelectEndTimeChange(moment) {
    this.setState({
      selectEndTime: moment
    })
  }

  handleStaffChange(e) {
    this.setState({
      staff: e.target.value
    })
  }


  handleSaveWorkTime(e) {
    e.preventDefault();
    const { toggleOpen, isSalaryEdit } = this.props;
    const { selectDate, selectStartTime,  selectEndTime, staff} = this.state;
    if (selectEndTime.diff(selectStartTime) <= 0) {
      swal({
        type: 'error',
        title: '時間輸入有誤',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    } else if (staff === 0 && !isSalaryEdit) {
      swal({
        type: 'error',
        title: '請選擇人員',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    }

    let data = {
      userId: staff,
      start: selectDate.format('YYYY-MM-DD') + ' ' + selectStartTime.format('LT'),
      end: selectDate.format('YYYY-MM-DD') + ' ' + selectEndTime.format('LT'),
      resourceId: 6,
      title: ""
    }
    this.props.saveWorkRecordFunc(data);
    toggleOpen();
  }
  
  handleSelectDateChange(moment) {
    this.setState({
      selectDate: moment
    })
  }

  render() {
    let { isVisible, toggleOpen, isSalaryEdit } = this.props;
    if (!isVisible) {
      return null;
    }
    return (
      <div className="u-editblock fadeIn" onClick={toggleOpen}>
        <div className="form-block" onClick={(e)=>{e.stopPropagation();}}>
    <div className="u-small-title">編輯員工上班紀錄</div>
          <form className="u-form">
            <div className="row">

                {
                  isSalaryEdit?
                  <div className="col-6 col-pad-12">
                  <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>員工：{this.props.allStaff[0].realName}</label>
  
                </div>
                  :
                  <div className="col-6 col-pad-12">
                    <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>員工：</label>
                    <select value={Number(this.state.staff)} className="u-form__select" 
                    onChange={this.handleStaffChange}
                    >
                    <option value="0" disabled>請選擇</option>
                    {
                      this.props.allStaff.map(staff => (
                        <option key={staff.id} value={staff.id}>{ staff.realName }</option>
                      ))
                    }
                    </select>
                  </div>
                }
                {
                  isSalaryEdit?
                  <div className="col-6 col-pad-12">
                    <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>日期：{this.props.allStaff[0].expectedDate}</label>
                  </div>
                  :
                  <div className="col-6 col-pad-12">
                  <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>日期：</label>
                  <DatePicker
                    id="addWork_date_picker_selectDate"
                    locale="zh-tw"
                    dateFormat="YYYY-MM-DD"
                    timeCaption="Time"
                    selected={this.state.selectDate}
                    onChange={this.handleSelectDateChange}
                    className="u-form__input mobile-hide"
                    disabledKeyboardNavigation
                    onChangeRaw={this.handleDateChangeRaw}
                    autoComplete='off'
                  />
                  <button
                      className="btn datepickinput desktop--hide"
                      onClick={(e) => {
                        e.preventDefault();
                        document.getElementById('addWork_date_picker_selectDate').click();
                      }}
                  >
                    {this.state.selectDate.format('l')}
                  </button>
                </div>
                }
            </div>
            <div className="row">
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>時段：</label>
                <DatePicker
                  id="addWork_date_picker_selectStartTime"
                  locale="zh-tw"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeCaption="Time"
                  timeFormat="HH:mm"
                  selected={this.state.selectStartTime}
                  onChange={this.handleSelectStartTimeChange}
                  className="u-form__input mobile-hide"
                  disabledKeyboardNavigation
                  onChangeRaw={this.handleDateChangeRaw}
                  autoComplete='off'
                />
                <button
                    className="btn datepickinput desktop--hide"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('addWork_date_picker_selectStartTime').click();
                    }}
                >
                  { this.state.selectStartTime.format('HH:mm')}
                </button>
              </div>
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right">至：</label>
                <DatePicker
                  id="addWork_date_picker_selectEndTime"
                  locale="zh-tw"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeCaption="Time"
                  timeFormat="HH:mm"
                  selected={this.state.selectEndTime}
                  onChange={this.handleSelectEndTimeChange}
                  className="u-form__input mobile-hide"
                  disabledKeyboardNavigation
                  disableNativeKeyboard
                />
                <button
                    className="btn datepickinput desktop--hide"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('addWork_date_picker_selectEndTime').click();
                    }}
                >
                  {this.state.selectEndTime.format('HH:mm')}
                </button>
              </div> 
            </div>
            <div className="u-notice">※此功能僅限處理漏打卡事件</div>

            <div className="u-btn-group right">
              <button className="btn btn-md save" onClick={this.handleSaveWorkTime}>儲存</button>
              <button className="btn btn-md cancel m-l-16" onClick={
                (e) => {
                  e.preventDefault();
                  toggleOpen();
                }
              }>取消</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default AddWorkTimeInSignInShiftBlock;